// extracted by mini-css-extract-plugin
module.exports = {"vertical-layout-wrapper":"course-unit-skeleton_vertical-layout-wrapper__09djW","vertical-layout-card-wrapper":"course-unit-skeleton_vertical-layout-card-wrapper__ndWn8"};